module.exports = __webpack_public_path__ + "img/slide-images-02.cb50cf4f.jpg";